import { createContext, useContext, useEffect, useMemo, useState } from "react";

const KEY = "wm_cart";
const Ctx = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } });
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);
  const value = useMemo(() => ({
    items,
    count: items.reduce((n, i) => n + i.qty, 0),
    total: Math.round(items.reduce((n, i) => n + i.price * i.qty, 0) * 100) / 100,
    add: (p, qty = 1) => setItems((cur) => {
      const ex = cur.find((i) => i.id === p.id);
      if (ex) return cur.map((i) => (i.id === p.id ? { ...i, qty: Math.min(20, i.qty + qty) } : i));
      return [...cur, { id: p.id, name: p.name, brand: p.brand, price: p.price, image: p.images?.[0] || "", qty }];
    }),
    setQty: (id, qty) => setItems((cur) => (qty < 1 ? cur.filter((i) => i.id !== id) : cur.map((i) => (i.id === id ? { ...i, qty: Math.min(20, qty) } : i)))),
    clear: () => setItems([]),
  }), [items]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useCart = () => useContext(Ctx);
